import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { formatDistanceToNow } from "date-fns";
import { useDataFreshnessTimestamps } from "hooks";
import { Row } from "components/Containers";
import Tooltip from "components/Tooltip";
import { TextLoader } from "components/Loader";

/**
 * ChecklistPercentageHeader component
 *
 * @param {string} tooltipId - The ID for the tooltip content, used to fetch the appropriate message.
 */
const ChecklistPercentageHeader = ({ tooltipId }) => {
  const { timestamps, loading } = useDataFreshnessTimestamps();
  const { missionRoleApplicants: timestamp } = timestamps || {};

  return (
    <Row gap="0.4rem" noWrap>
      <FormattedMessage id="Missions.Applicants.ApplicantChecklist" />
      {tooltipId && (
        <Tooltip
          tooltipId={loading || timestamp ? tooltipId : `${tooltipId}.NoTimestamp`}
          values={{
            timestamp: loading ? (
              <TextLoader width="6rem" />
            ) : timestamp ? (
              formatDistanceToNow(new Date(timestamp), { addSuffix: true })
            ) : null,
          }}
        />
      )}
    </Row>
  );
};

ChecklistPercentageHeader.propTypes = {
  tooltipId: PropTypes.string,
};

export default ChecklistPercentageHeader;
